export const OPEN_BADGES_BASE_PATH = '/open-badges';
export const LAST_ACTIVITY_DESC = '-last_activity_date';

export const COURSE_FIELDS = ['id', 'title', 'minutes_consumed', 'image_240x135', 'url'].join(',');
